import { Component} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PartnerCategory } from 'src/app/assabil-kernel/models/entities/control-tables/partner-category-entity';
import { PartnerCategoryType } from 'src/app/assabil-kernel/models/entities/control-tables/partner-category-type-entity';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { PartnerCategoryRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/partner-category-request';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';


@Component({
    selector: 'partner-category-widget',
    templateUrl: './partner-category-widget.component.html',
    styleUrls: ['./partner-category-widget.component.scss']
})

export class PartnerCategoryWidgetComponent extends BaseWidget {

  partnerCategory               : PartnerCategory = new PartnerCategory();


  constructor(
      protected masterDataService   : MasterDataService,
      protected toastr              : ToastrService,
      protected controlTablesService: ControlTablesService,
      protected leanUtilsService    : LeanUtilsService) {
      super(toastr, leanUtilsService);

      this.entityName = "partnerCategory";
  }

//------------------------------------------------------
setEntity(partnerCategory: PartnerCategory) {
    this.partnerCategory  = { ...partnerCategory };
    this.partnerCategory.partnerCategoryTypes = [];
    if (partnerCategory.partnerCategoryTypes) {
      for (let partnerCategoryType of partnerCategory.partnerCategoryTypes) {
        this.partnerCategory.partnerCategoryTypes.push({ ...partnerCategoryType });
      }
    }
}
//---------------------------------------------------------------------------------------

//---------------------------------------------------------------------------------------
  getEntity(){
    return this.partnerCategory;
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
  saveRow() : Promise<PartnerCategory>{
    let request: PartnerCategoryRequest = new PartnerCategoryRequest(this.controlTablesService.getUserInfo());
    request.partnerCategory = this.partnerCategory;
    return this.controlTablesService.save(this.entityName, request);
  }
//---------------------------------------------------------------------------------------


//----------------------------------------------------------------------
  new(){
    let partnerCategoryType : PartnerCategoryType = new PartnerCategoryType();
    partnerCategoryType.inserted = true;
    this.partnerCategory.partnerCategoryTypes.push(partnerCategoryType);
    this.partnerCategory.partnerCategoryTypes = [...this.partnerCategory.partnerCategoryTypes];
  }
//----------------------------------------------------------------------

}
